import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import '../../assets/css/login.scss';
import ViewHelper from '../../helpers/ViewHelper';

class TermsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: '',
      loadingCode: false,
      error: ''
    };
  }

  getTimesByDays(timeSlots, day) {
    let times = [];
    for (let i = 0; i < timeSlots.length; i++) {
      if (parseInt(timeSlots[i].day) === day) {
        times.push({
          start_time: moment(timeSlots[i].start_time, ['HH:mm']).format('hh:mm a'),
          end_time: moment(timeSlots[i].end_time, ['HH:mm']).format('hh:mm a')
        });
      }
    }
    return times;
  }

  render() {
    let bindiscount = this.props.bindiscount;
    let levels = bindiscount.BindiscountDiscount.BindiscountDiscountLevels;
    let items = bindiscount.BindiscountDiscount.BindiscountDiscountItems;
    let levelValues = [];
    let daysValue = '';
    if (bindiscount.BindiscountDiscount.BindiscountDiscountLevels.length > 0) {
      levelValues = bindiscount.BindiscountDiscount.BindiscountDiscountLevels.filter((lvl) => lvl.expenditure > 0).map((obj) => obj.expenditure);
    }
    if (bindiscount.applicable_time_type === 2 && bindiscount.BindiscountTimeSlots.length > 0) {
      let timeslots = _.uniqBy(bindiscount.BindiscountTimeSlots, function (item) {
        return item.day;
      });
      let daysIds = timeslots.map((obj) => parseInt(obj.day));
      let days = [];
      for (let i = 0; i < daysIds.length; i++) {
        let day = moment()
          .isoWeekday(daysIds[i] + 1)
          .format('dddd');
        days.push({
          name: day,
          id: daysIds[i]
        });
      }
      daysValue = days;
    }
    if (bindiscount.applicable_time_type === 1 && bindiscount.BindiscountTimeSlots.length > 0) {
      let daysIds = bindiscount.BindiscountTimeSlots.map((obj) => obj.day);
      let days = [];
      for (let i = 0; i < daysIds.length; i++) {
        let dayIndex = moment(daysIds[i]).day();
        let day = moment()
          .isoWeekday(dayIndex)
          .format('dddd');
        days.push({
          name: day,
          id: daysIds[i]
        });
      }
      daysValue = days;
    }

    if (bindiscount.applicable_time_type === 3 && bindiscount.BindiscountTimeSlots.length > 0) {
      let day = parseInt(bindiscount.BindiscountTimeSlots[0].day);

      let days = [];
      for (let i = 0; i < day; i++) {
        let day = moment()
          .isoWeekday(i + 1)
          .format('dddd');
        days.push({
          name: day,
          id: i
        });
      }

      daysValue = days;
    }
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.showModal}
          toggle={this.props.toggleModal}
          className="modal sub-modal-term"
        >
          <div className="modal-header no-border card-color d-flex justify-content-center">
            <h5 className="modal-title card-font-color">Terms & Conditions</h5>
          </div>
          <ModalBody className="background-skin overflow-hidden card-color">
            <div className='h-100' style={{ overflowX: 'hidden' }}>
              <ul className='me-3 mt-3'>
                {levelValues.length > 0 ? (<li className='card-font-color'>Valid on a minimum order of Rs {Math.min(...levelValues)}.</li>) : ''}
                {bindiscount.max_discount_amount !== 0 ? (<li className='card-font-color'>Discount capped at Rs {bindiscount.max_discount_amount}.</li>) : ''}
                {bindiscount.usage_limit_user !== 0 ? (<li className='card-font-color'>Limit of {bindiscount.usage_limit_user} redemption per user.</li>) : ''}

                <li className='card-font-color' >Valid on {bindiscount.BindiscountOrderTypes && bindiscount.BindiscountOrderTypes.map((ordertype, index) => {
                  return bindiscount.BindiscountOrderTypes.length - 1 !== index ? <span className='bin-order-type-font '>{ViewHelper.capitalizeFirstLetter(ordertype.OrderType.label)},&nbsp;</span> : <span className='bin-order-type-font'>{ViewHelper.capitalizeFirstLetter(ordertype.OrderType.label)}</span>;
                })} only.</li>
                {items.length > 0 ? (<li className='card-font-color'>Offer valid on {items.map((item, index) => items.length - 1 !== index ? item.label + ', ' : item.label)}</li>) : ''}
                {levels.length > 0 ?
                  levels.length === 1 ?
                    levels[0].expenditure !== 0 ? <li>{levels[0].reward + '% discount on order above Rs ' + levels[0].expenditure + '.'}</li> : ''
                    : <li>
                      {levels && levels.map((level, index) => {
                        return levels.length - 1 !== index ? level.reward + '% discount on order above Rs ' + level.expenditure + ', ' : level.reward + '% discount on order above Rs ' + level.expenditure + '.'
                      })}
                    </li> : ''}
                {bindiscount.BindiscountDiscount.discount_type === 1 ? <li>Offer valid on all Items.</li> : ''}
                <li className='card-font-color'>Eligible discounts are applied automatically at checkout. If you are applying multiple discounts, the promotion with the highest discount will be applied in case discount stacking is not allowed.</li>
                <li className='card-font-color'>{this.props._location.name} reserves the right to change or terminate the discount conditions without any notice.</li>
                {daysValue !== '' && bindiscount.applicable_time_type === 2 ? (<li className='card-font-color'>Valid on
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Day</th>
                        <th scope="col">Start Time</th>
                        <th scope="col">End Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {daysValue.map((o, index) => {
                        let count = 0;
                        let timeSlots = this.getTimesByDays(bindiscount.BindiscountTimeSlots, o.id);
                        return timeSlots.map((time, index) => {
                          count = count + 1;
                          return (
                            <tr>
                              <td>{count === 1 ? o.name : ''}</td>
                              <td>{time.start_time}</td>
                              <td>{time.end_time}</td>
                            </tr>
                          )
                        });

                      })
                      }
                    </tbody>
                  </table>
                </li>) : ''}
                {daysValue !== '' && bindiscount.applicable_time_type === 3 ? (<li className='card-font-color'>Valid on

                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Day</th>
                        <th scope="col">Start Time</th>
                        <th scope="col">End Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {daysValue.map((o, index) => {
                        let count = 0;
                        return (
                          <>
                            {bindiscount.BindiscountTimeSlots.length === 1 ?
                              <tr>
                                <td>{o.name}</td>
                                <td>{moment(bindiscount.BindiscountTimeSlots[0].start_time, ['HH:mm']).format('hh:mm a')}</td>
                                <td>{moment(bindiscount.BindiscountTimeSlots[0].end_time, ['HH:mm']).format('hh:mm a')}</td>
                              </tr>
                              :
                              bindiscount.BindiscountTimeSlots.map((row) => {
                                count = count + 1;
                                return (
                                  <tr>
                                    <td>{count === 1 ? o.name : ''}</td>
                                    <td>{moment(row.start_time, ['HH:mm']).format('hh:mm a')}</td>
                                    <td>{moment(row.end_time, ['HH:mm']).format('hh:mm a')}</td>
                                  </tr>
                                )
                              })

                            }
                          </>
                        )
                      })
                      }
                    </tbody>
                  </table>
                </li>
                ) : ''}
                {daysValue !== '' && bindiscount.applicable_time_type === 1 ? (<li className='card-font-color'>Valid on

                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Day</th>
                        <th scope="col">Start Time</th>
                        <th scope="col">End Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bindiscount.BindiscountTimeSlots.map((row, index) => {

                        return (
                          <tr>
                            <td>{row.day}</td>
                            <td>{moment(row.start_time, ['HH:mm']).format('hh:mm a')}</td>
                            <td>{moment(row.end_time, ['HH:mm']).format('hh:mm a')}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </li>
                ) : ''}

              </ul>
            </div>
          </ModalBody>
          <ModalFooter className="no-border card-color d-flex justify-content-center">
            <Button
              className="btn btn-primary no-border mt-2 w-50 branding-btn"
              onClick={this.props.toggleModal}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default TermsModal;
